export enum Actions {
  Archive = 'archive',
  Reply = 'reply',
  Delete = 'delete',
  Edit = 'edit',
  Restore = 'restore',
}
